var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "confirm",
    {
      attrs: {
        showMask: true,
        singleBtn: true,
        closeIcon: true,
        title: _vm.$t("tradeTxPairManage.changeFee", {
          symbol: _vm.txPair.symbol
        }),
        leftBtnTxt: _vm.$t("btn.submit"),
        leftBtnClick: _vm.trans,
        close: _vm.close
      }
    },
    [
      _c("div", { staticClass: "__row" }, [
        _c("div", { staticClass: "__row_t" }, [
          _vm._v(_vm._s(_vm.$t("tradeTxPairManage.currentMaker")))
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "__input_row __unuse_input __bold" }, [
          _vm._v(
            "\n            " + _vm._s(_vm.txPair.symbol) + "\n            "
          ),
          _c("span", { staticClass: "__right" }, [
            _vm._v(_vm._s(_vm.currMakerFee + "%"))
          ])
        ])
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "__row" },
        [
          _c("div", { staticClass: "__row_t" }, [
            _vm._v(
              "\n            " +
                _vm._s(_vm.$t("tradeTxPairManage.confirmFee")) +
                "\n            "
            ),
            _c("span", { staticClass: "__bold __right __blue" }, [
              _vm._v(_vm._s(_vm.maker ? _vm.maker + "%" : "0%"))
            ])
          ]),
          _vm._v(" "),
          _c(
            "slider",
            {
              staticClass: "change-fee-slider",
              attrs: {
                min: _vm.minFee,
                max: _vm.maxFee,
                default: +_vm.currMakerFee
              },
              on: { drag: _vm.makerChanged }
            },
            [
              _c("div", { staticClass: "speed" }, [
                _c("span", { staticClass: "__left" }, [
                  _vm._v(_vm._s(_vm.minFee))
                ]),
                _vm._v(" "),
                _c("span", { staticClass: "__right" }, [
                  _vm._v(_vm._s(_vm.maxFee + "%"))
                ])
              ])
            ]
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "__row" }, [
        _c("div", { staticClass: "__row_t" }, [
          _vm._v(_vm._s(_vm.$t("tradeTxPairManage.currentTaker")))
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "__input_row __unuse_input __bold" }, [
          _vm._v(
            "\n            " + _vm._s(_vm.txPair.symbol) + "\n            "
          ),
          _c("span", { staticClass: "__right" }, [
            _vm._v(_vm._s(_vm.currTakerFee + "%"))
          ])
        ])
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "__row" },
        [
          _c("div", { staticClass: "__row_t" }, [
            _vm._v(
              "\n            " +
                _vm._s(_vm.$t("tradeTxPairManage.confirmFee")) +
                "\n            "
            ),
            _c("span", { staticClass: "__bold __right __blue" }, [
              _vm._v(_vm._s(_vm.taker ? _vm.taker + "%" : "0%"))
            ])
          ]),
          _vm._v(" "),
          _c(
            "slider",
            {
              staticClass: "change-fee-slider",
              attrs: {
                min: _vm.minFee,
                max: _vm.maxFee,
                default: +_vm.currTakerFee
              },
              on: { drag: _vm.takerChanged }
            },
            [
              _c("div", { staticClass: "speed" }, [
                _c("span", { staticClass: "__left" }, [
                  _vm._v(_vm._s(_vm.minFee))
                ]),
                _vm._v(" "),
                _c("span", { staticClass: "__right" }, [
                  _vm._v(_vm._s(_vm.maxFee + "%"))
                ])
              ])
            ]
          )
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }